"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCorrespondencePartialData = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var CLIENT_INTEGRATION_URL = process.env.REACT_APP_BCG_TRANSFORMER_URL;
function loadCorrespondencePartialData(projectId, offset) {
    if (offset === void 0) { offset = 0; }
    return api_1.default.get("".concat(CLIENT_INTEGRATION_URL, "/project/").concat(projectId, "/correspondence"), { params: { offset: offset, limit: 10 } })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.loadCorrespondencePartialData = loadCorrespondencePartialData;
var api = {
    loadCorrespondencePartialData: loadCorrespondencePartialData,
};
exports.default = api;
